export const MAPBOX_ACCESS_TOKEN = "pk.eyJ1IjoiY2hhaXRhbnlhcGFuc2FyZSIsImEiOiJjbGRjdW5ydTMwMXowM29taTI0cmc2YzRtIn0.6LqjPEY3UNHRu26DMqhEow";

export const MAPBOX_STYLE_URL = "mapbox://styles/chaitanyapansare/cldcsupq4007e01oc7gvpb1ms";
export const MAPBOX_STYLE_URL2 = "mapbox://styles/chaitanyapansare/clfkntsw4000401qsodxky3xq";
